module.exports = __webpack_public_path__ + "img/sanda-2.13d890d4.png";